/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Link } from "react-router-dom";
import { Cell } from "react-table";
import { theme } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { AssignmentRule } from "~/models";
import { ROUTES } from "~/routing";
import { displayEnvType, displayLevel } from "~/tools";

type Props = {
  customerId: string;
};

export const AssignmentRulesListColumns = ({ customerId }: Props) => [
  {
    Header: "Name",
    accessor: "name",
    disableSortBy: true,
    width: "60%",
    Cell: ({ row }: Cell<AssignmentRule>) => {
      const ruleId = row.original.id;

      return (
        <Link
          css={{ color: theme.color.text.text01 }}
          to={`${ROUTES.customers.index}/${customerId}/assignment-rules/${ruleId}/`}
        >
          {row.original?.name}
        </Link>
      );
    },
  },
  {
    Header: () => (
      <FlexContainer justify="center">Environment Types</FlexContainer>
    ),
    accessor: "environmentTypes",
    disableSortBy: true,
    Cell: ({ row }: Cell<AssignmentRule>) => {
      const envs = row?.original?.environmentTypes;

      return (
        <FlexContainer justify="center" direction="column" align="center">
          {envs?.map((e: string) => (
            <div key={e}>{displayEnvType(e)}</div>
          ))}
        </FlexContainer>
      );
    },
  },
  {
    Header: "Service Level",
    accessor: "serviceLevel",
    disableSortBy: true,
    Cell: ({ row }: Cell<AssignmentRule>) => {
      const serviceLevel =
        row?.original?.attachedServiceLevel?.serviceLevel?.name;

      return (
        <FlexContainer justify="center" direction="column" align="center">
          {displayLevel(serviceLevel)}
        </FlexContainer>
      );
    },
  },
  {
    Header: () => (
      <FlexContainer justify="center" align="right">
        Number of Services
      </FlexContainer>
    ),
    accessor: "services",
    disableSortBy: true,
    Cell: ({ row }: Cell<AssignmentRule>) => {
      const numberOfServices = row?.original?.attachedServices.length;

      return (
        <FlexContainer justify="center" align="right">
          {numberOfServices}
        </FlexContainer>
      );
    },
  },
];
